/**
 * Single source of truth for rendering workspace tier labels in the UI.
 *
 * The canonical tier axis (S-WS-1) is exactly `starter · growth · scale ·
 * custom`. Legacy labels (`Free`, `Pro`, `Enterprise`) are retired — no UI
 * surface may render them. Every tier label shown to a user must derive from
 * `workspace_features.tier` through {@link getTierLabel}.
 *
 * @spec STATUS S-WS-1
 */
export const TIER_LABELS = {
  starter: "Starter",
  growth: "Growth",
  scale: "Scale",
  custom: "Custom",
} as const;

export type TierKey = keyof typeof TIER_LABELS;

/**
 * Map a `workspace_features.tier` value to its canonical display label. Unknown
 * values fall back to the raw input so callers never silently mislabel a tier.
 */
export function getTierLabel(tier: string): string {
  return TIER_LABELS[tier as TierKey] ?? tier;
}
